import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/14. Energy sources.png'

const ColdRooms = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'green_energy_sources')}
            text="Total Number of Energy Sources"
        />
    );
}

export default ColdRooms;